import { capitalizeFirstLetter } from "../../../lib/helpers/capitalizeFirstLetter";
import { EntityType } from "../../../api/grpc/subscription/subscription";

export const getAddonsName = (
  name: string,
  count: number,
  entityType?: EntityType
) => {
  if (entityType === EntityType.CROSS_ORG_ROOM_CALENDARS) {
    return "Cross-Org Shared Room Calendars";
  }

  if (entityType === EntityType.USERS_PACK) {
    return "Users";
  }

  return capitalizeFirstLetter(count <= 1 ? name : name + "s");
};
